import React from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import { Tag, Tooltip } from 'tdesign-react';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview }) {
  const items = [
    {
      title: 'Partitions',
      icon: 'other2',
      info: <CountUp end={overview.totalTopicPartitions} duration={0.4} />,
    },
    {
      title: 'Leaders',
      icon: 'topic',
      info: <CountUp end={overview.leaderTopicPartitions} duration={0.4} />,
    },
    {
      title: '机架感知',
      icon: 'other3',
      info: overview.hasRack ? (
        <Tooltip content={overview.racks}>
          <Tag size='small' theme='primary' variant='outline'>
            开启
          </Tag>
        </Tooltip>
      ) : (
        <Tag size='small'>关闭</Tag>
      ),
    },
  ];
  return <SummaryPanel shadow={false} img={null} items={items} />;
}

export default connect((state) => ({
  overview: state.kafkaBroker.singleOverview,
}))(Summary);
